import { AgColumnDefinition, AgGridColumnType } from '@/shared/models/ag-grid.model'
import i18n from '@/lang/i18n'
import { ValueGetterParams } from '@ag-grid-enterprise/all-modules'
import { PatientSearchResponse } from '@/api/services/patient/patient/patient.dto'
import { StoreUtils } from '@/shared/util/store-utils'

export const billingModalPatientSelectionGridColumnDefs =
    (): Array<AgColumnDefinition> => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            headerName: i18n.tc('global.name'),
            field: 'patName',
            type: AgGridColumnType.TEXT,
            minWidth: 150,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('grid.patMiddleName'),
            field: 'patMiddleName',
            type: AgGridColumnType.TEXT,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('global.surname1'),
            field: 'patSurname1',
            type: AgGridColumnType.TEXT,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('global.surname2'),
            field: 'patSurname2',
            type: AgGridColumnType.TEXT,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('global.gender'),
            field: 'genderName',
            type: AgGridColumnType.TEXT,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('global.birthday'),
            field: 'patBirthdate',
            type: AgGridColumnType.DATETIME,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerValueGetter: () => StoreUtils.globalParameters?.secondaryPatientIdentifierType.name,
            field: 'centerIdentifierCenterName',
            type: AgGridColumnType.TEXT,
            minWidth: 100,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerValueGetter: () => StoreUtils.globalParameters?.mainPatientIdentifierType.name,
            valueGetter: ({ data }: ValueGetterParams) => {
                const patient = data as PatientSearchResponse
                const mainPatientIdentifierType = StoreUtils.globalParameters?.mainPatientIdentifierType
                if (mainPatientIdentifierType) {
                    return patient.personIdentifiers[mainPatientIdentifierType.code]?.identifier ?? ''
                }
                return ''
            },
            type: AgGridColumnType.TEXT,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('NUHSA'),
            valueGetter: ({ data }: ValueGetterParams) => {
                const patient = data as PatientSearchResponse
                return patient.personIdentifiers['NUHSA']?.identifier ?? ''
            },
            type: AgGridColumnType.TEXT,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        }
    ]
